<template>
  <div style="display: inline-block">
    <v-btn
      color="primary"
      outline
      fab
      :loading="loadingAgentGroup || loadingAgentSubGroup || loadingUser"
      small
      @click="show = true"
    >
      <v-icon>create</v-icon>
    </v-btn>
    <v-dialog v-model="show" persistent max-width="600">
      <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup">
        <div class="text-xs-right">
          <v-btn small flat fab :loading="loadingUser" @click="onCancel">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="form-control px-1">
              <div class="caption mb-1 mt-2">Username *</div>
              {{ user.userid }}
            </v-flex>

            <template v-if="!['mitsuwebchat'].includes(selectedBot.theme)">
              <v-flex
                xs12
                sm6
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('group') }"
              >
                <div class="caption mb-1 mt-2">Group</div>

                <multiselect
                  v-model="user.group"
                  :options="agentGroup"
                  track-by="groupname"
                  label="groupname"
                  name="group"
                  :searchable="true"
                  select-label
                  selected-label
                  deselect-label
                  @input="onChangeGroup"
                ></multiselect>
                <p v-if="errors.has('group')" class="text-error">{{ errors.first('group') }}</p>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Subgroup</div>
                <multiselect
                  v-model="user.subgroup"
                  :options="filterSubGroup"
                  track-by="subgroupname"
                  label="subgroupname"
                  :searchable="true"
                  select-label
                  selected-label
                  deselect-label
                  @input="onChangeSubGroup"
                ></multiselect>
              </v-flex>
            </template>
          </v-layout>
          <v-divider class="my-3" />
          <div class="caption">Role</div>
          <v-layout wrap>
            <v-radio-group
              v-if="privilege && privilege.hasOwnProperty('role')"
              v-model="privilege.role"
              v-validate="'required'"
              row
              name="role"
              data-vv-as="Role"
              :error="errors.has('role')"
              :error-messages="errors.first('role')"
            >
              <template v-if="['powerbuy', 'mitsuwebchat'].includes(selectedBot.theme)">
                <v-radio color="primary" label="Super admin" value="superadmin"></v-radio>
                <v-radio color="primary" label="Admin" value="admin"></v-radio>
                <v-radio color="primary" label="Agency" value="agency"></v-radio>
              </template>
              <template v-else-if="selectedBot.theme == 'kingkitchen'">
                <v-radio color="primary" label="Sale" value="sale"></v-radio>
                <v-radio color="primary" label="SO" value="so"></v-radio>
                <v-radio color="primary" label="Call center" value="callcenter"></v-radio>
                <v-radio color="primary" label="ทีมติดตั้ง" value="installation"></v-radio>
              </template>
              <template v-else-if="selectedBot.theme == 'toaecoupon'">
                <v-radio color="primary" label="Admin" value="admin"></v-radio>
                <v-radio color="primary" label="ผู้จัดการฝ่าย Trade" value="trade"></v-radio>
                <v-radio
                  color="primary"
                  label="บัญชีผู้เสนอขออนุมัติ (Approval) "
                  value="approval"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="บัญชีผู้ช่วยผู้จัดการอนุมัติ (Approver 1)"
                  value="approver1"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="บัญชีผู้จัดการอนุมัติ (Approver 2)"
                  value="approver2"
                ></v-radio>
                <v-radio color="primary" label="Super admin" value="superadmin"></v-radio>
              </template>

              <template v-else-if="selectedBot.theme == 'seagull'">
                <v-radio color="primary" label="Admin" value="admin"></v-radio>
                <v-radio color="primary" label="Supervisor" value="supervisor"></v-radio>
                <v-radio color="primary" label="Agent" value="agent"></v-radio>
                <v-radio color="primary" label="คลังสินค้า" value="warehouse"></v-radio>
              </template>

              <template v-else-if="selectedBot.type == 'tigerpoly'">
                <v-radio color="primary" label="TPC" value="tpc"></v-radio>
                <v-radio color="primary" label="President" value="president"></v-radio>
                <v-radio color="primary" label="HR Manager" value="hrmanager"></v-radio>
                <v-radio color="primary" label="Admin" value="admin"></v-radio>
                <v-radio color="primary" label="Admin System" value="adminsystem"></v-radio>
              </template>

              <template v-else>
                <v-radio color="primary" label="Super admin" value="superadmin"></v-radio>
                <v-radio color="primary" label="Admin" value="admin"></v-radio>
                <v-radio color="primary" label="Manager" value="manager"></v-radio>
                <v-radio color="primary" label="Accounting" value="accounting"></v-radio>
              </template>
            </v-radio-group>
          </v-layout>

          <template
            v-if="['mitsuwebchat'].includes(selectedBot.theme) && privilege.role == 'admin'"
          >
            <v-layout class="mb-3">
              <v-flex
                xs12
                sm6
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('group') }"
              >
                <div class="caption mb-1 mt-2">Group *</div>
                <multiselect
                  v-model="user.group"
                  v-validate="'required'"
                  :options="agentGroup"
                  track-by="groupname"
                  label="groupname"
                  name="group"
                  :searchable="true"
                  select-label
                  selected-label
                  deselect-label
                  @input="onChangeGroup"
                ></multiselect>
                <p v-if="errors.has('group')" class="text-error">{{ errors.first('group') }}</p>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Subgroup</div>
                <multiselect
                  v-model="user.subgroup"
                  :options="filterSubGroup"
                  track-by="subgroupname"
                  label="subgroupname"
                  :searchable="true"
                  select-label
                  selected-label
                  deselect-label
                ></multiselect>
              </v-flex>
            </v-layout>
          </template>

          <div class="text-xs-center">
            <v-btn outline color="grey" :loading="loadingUser" @click="onCancel">{{
              $t('cancel')
            }}</v-btn>
            <v-btn color="primary" depressed :loading="loadingUser" @click="onSave">{{
              $t('Save')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageUser from './ManageUser.js'
export default {
  mixins: [ManageUser],
  data() {
    return {
      type: 'edit'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Agentmanagement/EditUser.vue